import { OrderStatusEnum } from "../../enums";
import { OrderModel } from "../../models";
import { formatDate } from "../../utilities";
import {
  FiCheck,
  FiClock,
  FiBox,
  FiCheckCircle,
  FiCalendar,
} from "react-icons/fi";
import { MdOutlineReceiptLong } from "react-icons/md";
import { RxCross2 } from "react-icons/rx";
import clsx from "clsx";

type Props = {
  order: OrderModel;
};

const OrderStatus: React.FC<Props> = ({ order }) => {
  const getIcon = (label: string) => {
    switch (label.toLowerCase()) {
      case "received":
        return <MdOutlineReceiptLong size={24} />;
      case "accepted":
        return <FiCheck size={24} />;
      case "ready":
        return <FiBox size={24} />;
      case "completed":
        return <FiCheckCircle size={24} />;
      case "cancelled":
        return <RxCross2 size={24} />;

      default:
        return <FiClock size={24} />;
    }
  };

  // Find the index of the last active step
  const activeStepIndex = order.status.reduce((acc, step, index) => {
    return step.active ? index : acc;
  }, -1);

  return (
    <div className="status-progress-container">
      <div className="status-steps">
        {order.status.map(({ id, label, active, status_ts }, index) => {
          // A step is considered "completed" if its index is less than the active step index,
          // OR if it's the active step and has a timestamp.
          const isCompleted = index < activeStepIndex || (active && status_ts);
          const isActive = index === activeStepIndex;
          const isCancelled = label.toLowerCase() === "cancelled";

          return (
            <div
              key={id}
              className={clsx(
                "status-step",
                isActive && "active",
                isCompleted && "completed",
                isCancelled && "cancelled",
              )}
            >
              <div className="step-icon">{getIcon(label)}</div>
              <div className="step-content">
                <div className="step-label">{label}</div>
                {status_ts && (
                  <div className="step-time">{formatDate(status_ts)}</div>
                )}
              </div>
            </div>
          );
        })}
      </div>

      {![OrderStatusEnum.COMPLETED, OrderStatusEnum.CANCELLED].includes(
        Number(order.status_id),
      ) ? (
        <div className="expected-pickup">
          <div className="pickup-icon">
            <FiCalendar />
          </div>
          <div>
            <label>Expected {order.order_type}</label>
            <span>{formatDate(order.estimated_delivery_time)}</span>
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default OrderStatus;
